export default __webpack_public_path__ + "8e9482bd4833db896956119727901437.png";